import router from '@/router'

const hasPermission = (element) => {
  var permissionArr = store.getters.permission
  return permissionArr.some(temp => element.indexOf(temp) >= 0)
}


const goBack = function () {
  window.history.length > 1
    ? router.go(-1)
    : router.push('/')
}

export default {
  install (Vue) {
    Object.defineProperties(Vue.prototype, {
      $goBack: {
        value: goBack
      }
    })
  }
}
